import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { CertificadosFsItemResultsViewModel, CertificadosFsItemViewModel } from '../buscador-certificadosfs.types';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { Mixin } from 'ts-mixer';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';

@Component({
    selector: 'app-buscador-certificadosfs-list',
    templateUrl: './buscador-certificadosfs-list.component.html',
    styleUrls: ['./buscador-certificadosfs-list.component.scss'],
})
export class BuscadorCertificadosFsListComponent extends Mixin(ListBase, ComponentBase) implements OnInit, OnChanges {
    @Input() result: CertificadosFsItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() edit = new EventEmitter<number | null>();
    @Output() download = new EventEmitter<CertificadosFsItemViewModel | null>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    constructor(
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const cvm = proxiedPropertiesOf<CertificadosFsItemViewModel>();
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Image', header: '' },
            { field: cvm.IdSolicitud?.toString(), header: 'Id', display: 'none' },
            { field: cvm.Codigo?.toString(), header: 'Código' },
            { field: cvm.NumeroCertificado?.toString(), header: 'Nº Certif. Fito' },
            { field: cvm.PuntoInspeccionDescripcion?.toString(), header: 'Punto Inspección' },
            { field: cvm.NifImportador?.toString(), header: 'NIF Importador' },
            { field: cvm.Importador?.toString(), header: 'Importador' },
            { field: cvm.Exportador?.toString(), header: 'Exportador' },
            { field: cvm.NifExportador?.toString(), header: 'NIF Exportador' },
            { field: cvm.IdPaisDestinoDescripcion?.toString(), header: 'País Destino' },
            { field: cvm.Utilizado?.toString(), header: 'Utilizado' },
            { field: cvm.Disponible?.toString(), header: 'Disponible' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter.PageNumber * this.result.PageSize; // i.e. página 4 * 15 elementos x página
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField,
        };

        this.search.emit(f);
    }

    onEdit(item: CertificadosFsItemViewModel) {
        this.edit.emit(item.IdSolicitud);
    }

    onDownload(item: CertificadosFsItemViewModel) {
        this.download.emit(item);
    }
}
